import { render, staticRenderFns } from "./InviteCustomer.vue?vue&type=template&id=e1002d06&"
import script from "./InviteCustomer.vue?vue&type=script&lang=ts&"
export * from "./InviteCustomer.vue?vue&type=script&lang=ts&"
import style0 from "./InviteCustomer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports